//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface iteamCategory {
  daypartcodes: string;
  itemname: string;
  itemcode: string;
 
}

interface ApiResponse {
  success: boolean;
  message: string;
  data: {
    iteamcategories: iteamCategory[];
  };
  responsecode: number;
  errormessage: string | null;
}

interface DishCategoriesState {
  categories: iteamCategory[]; 
  loading: boolean;
  error: string | null;
}

const initialState: DishCategoriesState = {
  categories: [],
  loading: false,
  error: null,
};

// Updated fetchIteamCategories function
export interface IteamCategoriesParams {
  userid: string | number;
  useridvalue?: number;
  fromdate?: string;
  todate?: string;
}

export const fetchIteamCategories = createAsyncThunk<iteamCategory[], IteamCategoriesParams>(
  'iteamCategories/fetchIteamCategories',
  async ({ userid, useridvalue, fromdate, todate, sitelistid }: IteamCategoriesParams) => {
    const payload: any = {
      userid,
    };

    // Optional fields: add only if provided
    if (typeof useridvalue !== 'undefined') payload.useridvalue = useridvalue;
    if (fromdate) payload.fromdate = fromdate;
    if (todate) payload.todate = todate;
    if (sitelistid && sitelistid.length > 0) payload.sitelistid = sitelistid;

    const response = await axiosInstance.post<ApiResponse>(
      `${BASE_URL}/api/v1/ItemWisePlanning/InitiateMenuPlanItemWise/GetSiteItemMasterData`,
      payload
    );   

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    // Support multiple response shapes. Examples we've seen:
    // 1) { data: { iteamcategories: [...] } }
    // 2) { data: [...] }
    // 3) { data: { data: [...] } }  (nested 'data' key)
    const rawData = response.data?.data;
    let categories: any[] = [];

    if (Array.isArray(rawData?.iteamcategories)) {
      categories = rawData.iteamcategories;
    } else if (Array.isArray(rawData)) {
      categories = rawData;
    } else if (Array.isArray(rawData?.data)) {
      // some responses wrap the array inside another `data` key
      categories = rawData.data;
    } else {
      categories = [];
    }

    // Debug/log the normalized categories
    // eslint-disable-next-line no-console
    console.debug('normalized iteam categories count:', categories.length);

    return categories;
  }
);


const iteamCategoriesSlice = createSlice({
  name: 'iteamCategories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIteamCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIteamCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchIteamCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '';
      });   
  },
});

// Export the reducer from the slice we created above
export default iteamCategoriesSlice.reducer;
